export const iconConfigStore = {};
